import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Firebase configuration for faircare-82071
// These are public client-side keys (safe to expose)
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDY_w7TJNw8-Ax3QPjXeZGlU8nSfi55hhk',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'faircare-82071.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'faircare-82071',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'faircare-82071.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '731027622622',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:731027622622:web:604be4374f3e4b3816104f',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;

